import React, {Component} from 'react';
import {FaMapMarkerAlt} from "react-icons/fa";
/*
This suspension was initiated by my wife adding an add with a link to our new site (irishdivorceservices.ie) and not our old site (irishidivorceservices.com). I changed the ad, but it did not make a difference. I deleted all ads and made just 1 new one with link to the new site. This also made no difference. I deduced that the problem must be with the site. I re-written the entire site and ensured that there is no dynamic content and that all links are valid. I've read the Circumventing Systems policy over and over, but I can't find anything there which applies to me.  I've been emailing someone called Gegan, but he doesn't reply to me now. I'm really at my wits end. I just don't know what more I can do.

Could you please send this for a another review and get back to me?
 */
class AutoCompletePopup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            arrowKeysIndex: -1,
        }
    }
    // nav the list with arrow keys
    // nav with mouse
    // select with mouse/keys/touch
    componentDidMount() {
        document.addEventListener("keydown",this.overlayKeyDownEvents)
    }
    componentWillUnmount() {
        document.removeEventListener("keydown",this.overlayKeyDownEvents)
    }
    overlayKeyDownEvents = (e) => {
        const self = this
        if (e.key === 'Tab' || e.key === 'Enter' || e.keyCode === 13){
            if (this.state.arrowKeysIndex > -1){
                this.props.handleSelection(this.props.suggestions[this.state.arrowKeysIndex].value)
            }
        }
        if (e.key === 'ArrowDown' || e.keyCode === 40) {
            e.preventDefault();
            self.setState(prevState=>{
                let index = self.state.arrowKeysIndex < this.props.suggestions.length - 1 ? prevState.arrowKeysIndex + 1 : 0
                return {
                    arrowKeysIndex: index
                }
            })
        }
        if (e.key === 'ArrowUp' || e.keyCode === 38) {
            e.preventDefault();
            self.setState(prevState=>{
                let index = self.state.arrowKeysIndex > 0 ? prevState.arrowKeysIndex - 1 : this.props.suggestions.length - 1
                return {
                    arrowKeysIndex: index
                }
            })
        }

    }



    highLight = (e) => {
        e.currentTarget.style.backgroundColor = '#d7f1f5'
    }
    unHighLight = (e) => {
        e.currentTarget.style.backgroundColor = ''
    }
    suggestionSelected = (val) => {
        this.props.handleSelection(val)
    }
    render() {
        return (
            <div className="py-0 card shadow-sm bg-lightblue" key='popover-card'>
                {this.props.suggestions.map((item, index) => {
                    const suggestionProps = {
                        onClick: (e) => {
                            this.suggestionSelected(item.value)
                        },
                        onMouseEnter: this.highLight,
                        onMouseLeave: this.unHighLight,
                    }
                    if (index === this.state.arrowKeysIndex){
                        suggestionProps.style={
                            backgroundColor: '#d7f1f5'
                        }
                    }
                    if (this.props?.address) {
                        return (
                            <React.Fragment key={'suggestion' + index}>
                                {index !== 0 && <hr className="my-0"/>}
                                <div {...suggestionProps} >
                                    <div className="px-2 d-flex gap-0 py-1 justify-content-start align-items-center">
                                        <div  className="flex-shrink-0 text-info">
                                            <FaMapMarkerAlt size={25}/>
                                        </div>

                                        <div className="px-2 d-flex flex-column justify-content-start gap-1" >
                                            <p className="bold mb-0">{item.label}</p>
                                            <small className="text-muted">{item.text}</small>
                                        </div>
                                    </div>
                                </div>
                            </React.Fragment>
                        )
                    }
                    else {
                        return (
                            <React.Fragment key={'suggestion' + index}>
                                {index !== 0 && <hr className="my-0"/>}
                                <div {...suggestionProps} >
                                    <div className="px-3 d-flex gap-0 py-1 justify-content-start align-items-center">
                                        <p className="bold my-1">{item.label}</p>
                                    </div>
                                </div>
                            </React.Fragment>
                        )
                    }
                })}
            </div>
        )
    }
}

AutoCompletePopup.propTypes = {};

export default AutoCompletePopup;